import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const DeviceViewModule = new Module({
  id: 'DEVICE:VIEW:RESULT-TABLE',
  name: 'Device',
  label: 'Device',
  path: 'device',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Devices/View'))
  ),
  actions: {
    tagToBackend: {
      id: 'DEVICE:TAG:RESULT-TABLE',
      name: 'tag-backend',
      label: 'Tag To Backend'
    }
  }

});

const DeviceModules = [DeviceViewModule];

export default new ModuleBundle('Device', DeviceModules);
